import { BaseFetch } from "../main-model"
export default class OnetScoreModel extends BaseFetch {
    getOnetScoreBy = (data) =>
        this.authFetch({
            url: "onet_score/getOnetScoreBy",
            method: "POST",
            body: JSON.stringify(data),
        })
        getOnetScoreById = (data) =>
        this.authFetch({
            url: "onet_score/getOnetScoreById",
            method: "POST",
            body: JSON.stringify(data),
        })
        insertOnetScore = (data) =>
        this.authFetch({
            url: "onet_score/insertOnetScore",
            method: "POST",
            body: JSON.stringify(data),
        })
        updateOnetScoreId = (data) =>
        this.authFetch({
            url: "onet_score/updateOnetScoreId",
            method: "POST",
            body: JSON.stringify(data),
        })
        deleteOnetScoreId = (data) =>
        this.authFetch({
            url: "onet_score/deleteOnetScoreId",
            method: "POST",
            body: JSON.stringify(data),
        })
        getOnetScoreStudentBy = (data) =>
        this.authFetch({
            url: "onet_score/getOnetScoreStudentBy",
            method: "POST",
            body: JSON.stringify(data),
        })

        
}
